import {
  Skeleton,
  SkeletonLine,
  SkeletonRegion,
} from "@/components/ui/skeleton";
import { cn } from "@jbnl/shared-ui";

/**
 * The caller spells out the action cluster rather than counting it: its widths decide where the
 * row's left column ends.
 */
export function RowListSkeleton({
  rows = 4,
  subtitle = false,
  actions = [],
  rowClassName,
  labelClassName,
}: {
  rows?: number;
  /** Draw the smaller second line the real row has under its name. */
  subtitle?: boolean;
  /** One Tailwind size class per control at the right end of the row, in their order. */
  actions?: string[];
  /** The real `<li>`'s own spacing, where it is not the usual `py-2`. */
  rowClassName?: string;
  /** The padding the real row's name block carries, where it is a button rather than a span. */
  labelClassName?: string;
}) {
  return (
    <SkeletonRegion>
      <ul className="divide-y">
        {Array.from({ length: rows }, (_, row) => (
          <li
            key={row}
            className={cn(
              "flex items-center justify-between gap-3 py-2",
              rowClassName,
            )}
          >
            <span className={cn("block min-w-0 flex-1", labelClassName)}>
              {/* `base`, not `sm`: these rows carry the card's own type size, and a line of it
                  is four pixels taller than a line of `text-sm`. */}
              <SkeletonLine size="base" className="w-44" />
              {subtitle && <SkeletonLine size="xs" className="w-56" />}
            </span>
            <span className="flex shrink-0 items-center gap-1">
              {actions.map((action, index) => (
                <Skeleton key={index} className={cn("h-8", action)} />
              ))}
            </span>
          </li>
        ))}
      </ul>
    </SkeletonRegion>
  );
}
